export default "__VITE_ASSET__Ctcd9jAX__"